itsoftApp.createModule("notice", ["windowResize", "cookie"], function () {
    const saveButtons = document.querySelectorAll(".js-save");

    Array.prototype.forEach.call(saveButtons, function (saveButton) {
        const notice = saveButton.closest("[data-save]");
        const notSaveButton = notice.querySelector(".js-not-save");
        let dAttrSave;

        saveButton.addEventListener("click", function (evt) {
            evt.preventDefault();

            if (notice) {
                notice.classList.add("g-hidden");
                itsoftApp.modules.cookie.setCookie(notice);
            }
        });

        notSaveButton.addEventListener("click", function (evt) {
            evt.preventDefault();
            if (notice) {
                notice.classList.add("g-hidden");
            }
        });
    });
});